MemberMiniProfileView = require 'views/member-menu-profile/member-mini-profile-view'
PopOver = require 'views/lib/pop-over'
templates = require 'views/internal/templates'

module.exports = class CardMemberMenuView extends MemberMiniProfileView
  events:
    'click .js-remove-member': 'removeMember'

  initialize: ->
    super
    @card = @options.card
    return

  renderMenu: ->
    @$el.append(templates.fillMenu('member_on_card_menu', @model.toJSON(), { editable: @card.editable() }))
    @

  removeMember: (e) ->
    PopOver.hide()
    modelId = @model.id
    @card.removeMember(modelId)

    return



// WEBPACK FOOTER //
// ./app/scripts/views/member-menu-profile/card-member-menu-view.coffee